import { render, staticRenderFns } from "./FormulationCustomerRelatedDataTab.vue?vue&type=template&id=3af42990&scoped=true&"
import script from "./FormulationCustomerRelatedDataTab.vue?vue&type=script&lang=js&"
export * from "./FormulationCustomerRelatedDataTab.vue?vue&type=script&lang=js&"
import style0 from "./FormulationCustomerRelatedDataTab.vue?vue&type=style&index=0&id=3af42990&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3af42990",
  null
  
)

export default component.exports